import { Card, H6 } from "@sellar-io/components";
import { ComponentProps, ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "../../../../components";
import { Switch } from "@sellar-io/components";
import { SlideTransition } from "../../../../components/transition/SlideTransition";

export const FilterCard = (props: ComponentProps<typeof Card>) => {
  return (
    <Card
      {...props}
      className={twMerge(
        "bg-white",
        "flex w-full justify-between border border-solid border-gray-300 px-4 py-3",
        props.className,
      )}
    />
  );
};

export const FilterBadge = ({
  children,
  onClick,
  selected,
  className,
}: {
  children: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "min-h-[35px] cursor-pointer rounded-full bg-neutral-100 px-3 py-2 text-sm font-semibold transition-colors hover:bg-neutral-200",
        selected && "bg-neutral-500 text-white hover:bg-neutral-500",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const FilterSwitch = ({
  title,
  checked,
  onChange,
}: {
  title: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => {
  return (
    <div className={"flex gap-3"}>
      <Switch checked={checked} onChange={onChange} />
      <H6>{title}</H6>
    </div>
  );
};

export const CollapsableFilterCard = ({
  header,
  children,
}: {
  header: ReactNode;
  children: ReactNode;
}) => {
  const [active, setActive] = useState(true);

  return (
    <FilterCard className={"flex flex-col gap-4"}>
      <div className={"flex justify-between"}>
        <div className={"flex items-center"}>{header}</div>
        <Icon
          className={"cursor-pointer"}
          icon={active ? "CHEVRON_UP" : "CHEVRON_DOWN"}
          onClick={() => setActive((active) => !active)}
        />
      </div>
      <SlideTransition show={active} className={"flex flex-wrap gap-2"}>
        {children}
      </SlideTransition>
    </FilterCard>
  );
};
